import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #27: New React Indie Bundle page almost done",
  "description": "",
  "published": "2016-11-21T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-27-new-react-indie-bundle-page-almost-done/swizec/7237"],
  "categories": "Front End, Livecoding, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New streams almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`Continuing from `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-26-new-page-react-indie-bundle/swizec/7211"
      }}>{`last week`}</a>{`, we kept putting together the new page for the React Indie Bundle. I wanted to get it done this weekend, but then I didn't.`}</p>
    <p>{`Launching the first version tomorrow is getting tight ?`}</p>
    <p>{`To be honest, nothing crazy technical happened in this livecoding session. Slapping together content in React components followed by more slapping together of content.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/11/Screen-Shot-2016-11-21-at-13.40.35-1024x539.png",
        "alt": null
      }}></img></p>
    <p>{`It's really a somewhat repetitive process. Maybe there's a market for building React-ready templates? Just like most templates you buy now are built with Bootstrap so they're easy to customize, it would be cool if in the future we could get some that are built with React.`}</p>
    <p>{`Then instead of getting a bunch of HTML like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-HTML4strict"
      }}>{`<div class="box-hex flat-shadow box-huge">
    <div class="box-dummy"></div>
        <figure class="box-inner">
            <img class="svg-inject" src="image_src" alt="alt_text">
        </figure>
        <figcaption class="box-caption">
            <h4>Says</h4>
            I like ancient stuff
        </figcaption>
<div class="hex-right"></div><div class="hex-left"></div></div>
<h3 class="text-center">
  <a href="some">
    John Langan
  </a>
  <small class="block">Art Director</small>
</h3>
<p class="text-center">some text</p>
<ul class="list-inline text-center social-icons social-simple">
  <li>
      <a href="some" target="_self">
          <i class="fa fa-facebook"></i>
      </a>
  </li>
  <li>
      <a href="some" target="_self">
          <i class="fa fa-twitter"></i>
      </a>
  </li>
</ul>
`}</code></pre>
    <p>{`Which you have to manually retype, or copypasta, into an `}<inlineCode parentName="p">{`Author`}</inlineCode>{` component like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-HTML4strict"
      }}>{`export const Author = ({ src, name, title, description, links }) => (
    <div>
        <div class="box-hex flat-shadow box-huge">
            <div class="box-dummy">
            <figure class="box-inner">
                <img class="svg-inject" src={src} alt={name} style="{{height:" "217px"}}="">
            </figure>
        </div>
        <h3 class="text-center">
            {name}
            <small class="block">{title}</small>
        </h3>
        <p class="text-center">{description}</p>
        <ul class="list-inline text-center social-icons social-simple">
            {Object.keys(links).map((type, i) => (
                <li key={i}>
                    <a href={links[type]} target="_self">
                        <i class="{\`fa" fa-\${type}\`}="">
                    </i></a><i class="{\`fa" fa-\${type}\`}="">
                </i></li><i class="{\`fa" fa-\${type}\`}="">
             ))}
        </i></ul><i class="{\`fa" fa-\${type}\`}="">
    </i></div><i class="{\`fa" fa-\${type}\`}="">
);
</i></div>
`}</code></pre>
    <p>{`_`}{`The template would give you `}<inlineCode parentName="p">{`<Person />`}</inlineCode>{` by default. Is React still too hard for designers to grok? I know many of them understand HTML ?Then again, if you look at that, you'll see that the conversion looks a bit like this:- `}<inlineCode parentName="p">{`class`}</inlineCode>{` becomes `}<inlineCode parentName="p">{`className`}</inlineCode></p>
    <ul>
      <li parentName="ul">{`content becomes `}<inlineCode parentName="li">{`{something}`}</inlineCode></li>
      <li parentName="ul">{`repetitive content becomes `}<inlineCode parentName="li">{`thing.map(<loop stuff>)`}</inlineCode>{`Almost sounds like you could automate that. Or is it juuuuuust tricky enough that you need a junior developer of some sort?Definitely a junior developer job, if you have access to one of those. Otherwise ,you gotta schlep through it yourself.But as my CTO would say, if a landing page can mean the difference between $0 and $60,000 in revenue, why `}<em parentName="li">{`wouldn't`}</em>{` you build it yourself?`}{`_`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      